import React, { ReactNode } from 'react';
import styles from './assets/payment-screen.module.scss';
import classNames from 'classnames';
import PaymentsGrid from './components/PaymentsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreatePaymentButton from './components/CreatePaymentButton';

import { IPayment } from 'src/types/payment';
import RoleLayout from '../../../../../../components/layout/RoleLayout';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IPayment>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class PaymentsList extends React.Component<Props> {
    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;

        return (
            <RoleLayout>
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>
                        PAYMENTS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    <CreatePaymentButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <PaymentsGrid data={data} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default PaymentsList;
